import { render } from "./ClassInfoPopupComponent2.vue?vue&type=template&id=20b2d99a&scoped=true"
import script from "./ClassInfoPopupComponent2.vue?vue&type=script&lang=js"
export * from "./ClassInfoPopupComponent2.vue?vue&type=script&lang=js"

import "./ClassInfoPopupComponent2.vue?vue&type=style&index=0&id=20b2d99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b2d99a"]])

export default __exports__